// Stage 1 "Silent defaults" · group G3 (W9 / W10 / W11 / consistency) — Code Health Report V1 findings A-4, A-11, A-13, A-12,
// A-19, A-20. New screen texts EN + AR, merged into lib/i18n.js (big-file rule).
export const I18N_SD_G3 = {
  en: {
    sdg3: {
      w11: {
        nothingToCompare: "Nothing to compare yet",                                     // A-11: consistency check compared nothing
      },
      w10: {
        answersNotConcluded: "{n} answers, not concluded",                             // A-13: form filled but no conclusion
      },
      w17: {
        repDateNotChecked: "Not checked — the representation date or the report date is not set yet.",   // A-12
      },
      w9: {
        notEvaluated: "not evaluated",                                                 // A-19: sample has no evaluation yet
        materialityNotSet: "Materiality not set",                                      // A-20: % of PM / OM has no denominator
      },
    },
  },
  ar: {
    sdg3: {
      w11: {
        nothingToCompare: "لا شيء للمقارنة بعد",
      },
      w10: {
        answersNotConcluded: "{n} إجابة، بدون استنتاج",
      },
      w17: {
        repDateNotChecked: "لم يُفحص — تاريخ الإفادة أو تاريخ التقرير غير محدَّد بعد.",
      },
      w9: {
        notEvaluated: "لم تُقيَّم",
        materialityNotSet: "الأهمية النسبية غير محدَّدة",
      },
    },
  },
};

export default I18N_SD_G3;
